































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import CusDatePicker from '@/components/controls/cus-date-picker.vue';
import VWidget from '@/components/VWidget.vue';
import Util from '@/lib/util';
import ListBase from '@/lib/listbase';
import ChartOperation from './chart-operation.vue';
import Widgets from './widgets.vue';
import DealerMap from '@/views/admin/dealer/map.vue';

@Component({
    components: { CusDatePicker, VWidget, ChartOperation, Widgets, DealerMap },
    data() {
        return {
        }
    },
})

export default class HomeView extends ListBase {
    loadingA: boolean = false;
    trans_items: Array<any> = [
        { key: 'nro_payments', label: 'Nro Transacciones', value: '0' },
        { key: 'total_payments', label: 'Monto Recibido', value: 'S/ 0' }
    ];
    opear_items: Array<any> = [
        { key: 'total_quotations', label: 'Cotizaciones', value: 'S/ 0' },
        { key: 'total_orders', label: 'Ordenes de Pedido', value: 'S/ 0' },
        { key: 'total_sales_f', label: 'Facturas', value: 'S/ 0' },
        { key: 'total_sales_b', label: 'Boletas', value: 'S/ 0' },
        { key: 'total_delivery', label: 'Notas de Salida', value: 'S/ 0' },
        { key: 'total_credit_notes', label: 'Notas de Credito', value: 'S/ 0' },
        { key: 'total_debit_notes', label: 'Notas de Debito', value: 'S/ 0' }
    ];

    get loading() {
        return this.$store.state.dashboard.loading;
    };

    get loadingDealers() {
        return this.$store.state.dealer.loading;
    };

    get dashActivity() {
        return this.$store.state.dashboard.activity;
    };

    formatPrice(price) {
        let sign = Util.abp.setting.get('DEFAULT_CURRENCY_SIGN');
        return sign + ' ' + Math.round(price);
    }

    async loadActivities() {
        this.loadingA = true;
        await this.$store.dispatch({
            type: 'dashboard/getDashActivity'
        });
        this.loadingA = false;
    }

    async loadDealers() {
        let list = await this.$store.dispatch({ type: 'dealer/getAllActive' });
        setTimeout(() => {
            if (this.$refs.map != undefined)
                (this.$refs.map as any).init();
        }, 100);
    }

    async mounted() {
    }

    async created() {

    }
}
